import { useEffect } from "react";
import { useSearchParams, useOutlet } from "react-router-dom";
import useIntlStore from "@/stores/useIntlStore";
import { RawIntlProvider } from "react-intl";
import type { Locale } from "@/types/global";
import AnimationProvider from "../AnimationProvider";
import { TiConfigProvider } from "@ti/ui-mobile";

const RootLayout = () => {
  const [searchParams] = useSearchParams();
  const outlet = useOutlet();

  const { intl, createIntl, locale } = useIntlStore();

  const initApplicationConfig = () => {
    const _locale = searchParams.get("locale");

    if (_locale) {
      createIntl(_locale as Locale);
    }
  };

  useEffect(() => {
    initApplicationConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TiConfigProvider locale={locale}>
      <RawIntlProvider value={intl}>
        <AnimationProvider>{outlet}</AnimationProvider>
      </RawIntlProvider>
    </TiConfigProvider>
  );
};
export default RootLayout;
